import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, NgZone } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { SessionInfo, personalInfo } from 'src/app/models/User';
import { CookieService } from 'ngx-cookie-service';

import { take } from 'rxjs/operators';
import { LoginService } from '../../services/checkout-services/login.service';
import { MobileComponent } from 'src/app/pages/checkout-process/mobile/mobile.component';
import { MatBottomSheet } from '@angular/material';
import { ApplicationStateService } from 'src/app/services/application-state.service';
import { AuthService } from '../../services/auth.service';
import { GetCartService } from '../../services/cart/get-cart.service';
import { CartItemsService } from '../../services/cart-items.service';
import { SharingService } from 'src/app/services/sharing.service';
import { IsCartEmptyService } from 'src/app/services/is-cart-empty.service';
import { LoginNameService } from 'src/app/services/login-name.service';
import { map, tap } from 'rxjs/operators';
import { OnelapCheckoutLoginEventService } from 'src/app/pages/checkout-process/onelap-chekout-login/onelap-checkout-login-event.service';
import { environment } from 'src/environments/environment';
import { BigDeal, FestivalDealService } from 'src/app/services/festival-deal.service';
import { Utils } from 'src/app/Utils';
import { ExternalRouterService } from 'src/app/services/external-router.service';
import { AppConfigService } from 'src/app/app-config.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  isDeal: boolean = environment.isDeal;
  session = new SessionInfo();
  path = '/login';
  user = 'Login';
  quickBuy = false;
  headerpointImg = 'assets/images/headerpoint.png';
  tricolorImg = 'assets/images/tricolor.png';
  logoImg = 'assets/images/logo.png';
  phonesvgImg = 'assets/images/phone.svg';
  cartItems = 0;
  logIcon = 'person';
  myObserver = null;
  userLogged = true;
  hasProductsInCart: boolean = false;
  softwareLink = 'https://play.google.com/store/apps/details?id=in.onelap.gpstracker&hl=en';
  trackerLink = 'https://www.amazon.in/Onelap-Telematics-Micro-Waterproof-Tracker/dp/B07YQXZ5DS/ref=sr_1_3?crid=3AC2XR9WA5LS2&keywords=onelap+gps+tracker&qid=1579072617&sprefix=Onelap%2Caps%2C313&sr=8-3';
  personal$ = this.onelapCheckoutLoginEventService.getPersonalEvent();
  dealLottieConfig: Object = null;
  lottieConfig: Object = null;
  cart;
  isProductPage: boolean = false;
  private scrollHandler: any = null;
  private animationTimeouts: Array<number | ReturnType<typeof setTimeout>> = [];
  private animationHandlers: Array<{el: Element, eventName: string, handler: EventListener}> = [];
  constructor(private router: Router,
    
    private appConfigService: AppConfigService,
    private externalRouter: ExternalRouterService,
    private _cookie: CookieService,
    private loginService: LoginService,
    private _bottomSheet: MatBottomSheet,
    private applicationStateService: ApplicationStateService,
    private cd: ChangeDetectorRef,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef,
    private authenticationService: AuthService,
    private cartService: GetCartService,
    private cartItemsService: CartItemsService,
    private isCartEmpty: IsCartEmptyService,
    private loginNameService: LoginNameService,
    private onelapCheckoutLoginEventService: OnelapCheckoutLoginEventService,
    private festivalDealService: FestivalDealService
  ) {
    this.lottieConfig = {
      path: 'assets/logo.json',
      autoplay: true,
      loop: true
    };
    //this.dealLottieConfig =undefined;

    this.loginNameService.getObservable().pipe(map(x => {
      return x;
    })).subscribe(x => {
      this.user = x;
    });
    this.isMobileResolution = this.applicationStateService.getIsMobileResolution();

    if (!this.isMobileResolution) {
  this.router.events.subscribe((event) => {
    if (event instanceof NavigationEnd) {
      const isHomePage = ['/', '/home', '/home#callback','/chat-with-ai'].includes(this.router.url);
      const navElements = document.getElementsByClassName('nav') as HTMLCollectionOf<HTMLElement>;

      if (navElements.length > 0) {
        const primaryNav = navElements[0];
        const secondaryNav = navElements.length > 1 ? navElements[1] : null;

        if (!isHomePage) {
          this.isMobileResolution = true;
          primaryNav.style.top = '0px';
          if (secondaryNav) secondaryNav.style.display = 'none';
        } else {
          this.isMobileResolution = false;
          primaryNav.style.top = '35px';
          if (secondaryNav) secondaryNav.style.display = '';
        }

        this.cd.markForCheck();
      }
    }
  });
}


  
    this.cartItemsService.currentApprovalStageMessage
      .pipe(
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe(
        (data) => {
          // Update the flag based on incoming cart updates
          if (data && data.body && data.body.products && data.body.products.length > 0) {
            this.hasProductsInCart = true;
          } else {
            this.hasProductsInCart = false;
          }

          // console.log("Has Products in Cart:", this.hasProductsInCart);
        },
        (error) => {
          console.error("Error in subscription:", error);
        }
      );
  


    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        if (this._cookie.get('UserID') && this.userLogged) {
          this.logIcon = 'how_to_reg';
          this.path = '/account/order';
          this.session.userId = this._cookie.get('UserID');
          this.session.Authorization = this._cookie.get('Authorization');

          this.loginService.get(this.session)
            .subscribe(x => this.user = x.body.firstName);
          this.userLogged = false;
        }
        if (!this._cookie.get('UserID')) {
          this.user = 'Login';
          this.path = '/login';
          this.userLogged = true;
        }
      }
    });
  }

  public isMobileResolution = false;
  d;
  e;
  productQuantities: { [key: string]: number } = {};
  ngOnInit() {
    this.ngOnChanges();
    
    this.router.events.subscribe(() => {
      const url = this.router.url;
      this.isProductPage =
        url.startsWith('/gps-tracking-devices/') ||
        /^\/gps-tracker-[a-zA-Z0-9-]+/.test(url);
    });
    
    this.check();
    this.isCartEmpty.isCartEmpty$.subscribe((x: boolean) => {
      if (!x) {
        this.cartItems = 0;
      }
    });
  
  }

  login() {
    this.rzpLogin();
  }

  magicRazorpayLogin() {
    Utils.magicLogin();
  }


get isUserLoggedIn(): boolean {
  return !!this._cookie.get('UserID');
}


  rzpLogin() {
    if (this.applicationStateService.getIsMobileResolution()) {
      if (this._cookie.get('UserID')) {
        this.router.navigate(['/my-account']);
      } else {
        const sheet = this._bottomSheet.open(MobileComponent);
        sheet.backdropClick().subscribe(() => {
          sheet.dismiss()
        });
      }
    } else {
      this.router.navigate([this.path]);
    }
    this.check();
  }
  showForm(){
    const redirect= "https://wa.me/917217760961?text="+Utils.getWhatAppHiiText();// + str1;
    window.open(redirect, "_blank");
  //  this._bottomSheet.open(LeadInfoComponent);
  }

  gotoProducts() {
    this.check();
    this.router.navigate(['/gps-tracking-devices']);
  }

  gotoCart() {
    this.check();
    const isMagicCheckoutEnabled = this.appConfigService.config.MAGIC_CHECKOUT_ENABLED != null
      ? this.appConfigService.config.MAGIC_CHECKOUT_ENABLED
      : environment.MAGIC_CHECKOUT_ENABLED;

    if (isMagicCheckoutEnabled) {
      let x = Utils.isLandedFromQuickBuyLink(this.externalRouter);
      if (x) {
        return;
      }
      this.router.navigate(['/cart']);
    }
    else {
      if (this.applicationStateService.getIsMobileResolution()) {
        Utils.checkOutInMobile('', this.authenticationService, this._cookie, this.externalRouter);
      }
      else {
        Utils.checkOutInDesktop("", this._cookie, this.externalRouter);
      }
    }
  }

  gotoRefer() {
    this.check();
    this.router.navigate(['/refer']);
  }

  scroll() {
    (document.getElementsByTagName("input") as any).name.focus();
  }

  handleNavbar() {
    const url = this.router.url;
    const navbar = document.querySelector('.navbar') as HTMLElement;

    if (url === '/' || url === '/home' || url === '/home#callback' ) {
      navbar.style.top = '45px';
    }

    if (window.innerWidth > 393) {
      if(window){
        this.scrollHandler = () => {
          navbar.style.top = window.scrollY > 100 ? '0px' : '45px';
        };
        window.addEventListener('scroll', this.scrollHandler);
      }
    } else {
      navbar.style.top = '0px';
    }
  }

  onClick() {
    this.check();
    this.router.navigate(['home'], { fragment: 'callback' });
  }

  ngOnChanges() { }

  ngOnDestroy(): void {
    // Remove scroll event listener if added
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
      this.scrollHandler = null;
    }
    // Clear all animation timeouts
    this.animationTimeouts.forEach(timeout => {
      // Type guard for NodeJS.Timer vs number
      if (typeof timeout === 'number' || typeof timeout === 'undefined') {
        clearTimeout(timeout as number);
      } else {
        clearTimeout(timeout);
      }
    });
    this.animationTimeouts = [];
    // Remove all animation event listeners
    this.animationHandlers.forEach(({el, eventName, handler}) => {
      el.removeEventListener(eventName, handler);
    });
    this.animationHandlers = [];
  }

  check() {
    if (this._cookie.get('paymentID')) {
      if (this._cookie.get('addressId')) {

      } else {
        this.quickBuy = true;
      }
    }
  }

  gotoQuickbuy() {
    const id = this._cookie.get('quickBuyId');
    this.router.navigate(['quickbuy/' + id]);
  }

  bigDealInit(deals: BigDeal[]) {
    if (deals.length !== 0) {
      const deal: BigDeal = deals[0];
      this.isDeal = (new Date(deal.end) as any) - Date.now() > 0 ? true : false;
      if (deal.dealBanners !== null && deal.dealBanners.length !== 0) {
        for (let banner of deal.dealBanners) {
          if (this.isDeal) {
            if (banner.device === 'LOGO' && banner.src) {
              this.dealLottieConfig = {
                path: banner.src,
                autoplay: true,
                loop: true
              }
              this.lottieConfig = undefined;
            }
          }
        }
      }
    }
  }

ngAfterViewInit() {
  const animationstart = 'animated slide fadeIn delay-1s';
  const animationend = 'animated slide fadeOut delay-0s';
  const animationEndEvents = 'animationend oAnimationEnd mozAnimationEnd webkitAnimationEnd MSAnimationEnd'.split(' ');
  const inter = 650;
  this.ngZone.run(() => {
    for (let i = 0; i < 5000; i++) {
      const timeout = setTimeout(() => {
        const elements = document.querySelectorAll('h1.animateThis');
        elements.forEach((el) => {
          el.classList.remove(...animationend.split(' '));
          el.classList.add(...animationstart.split(' '));
          // Define handler function
          const handler = () => {
            el.classList.remove(...animationstart.split(' '));
            el.classList.add(...animationend.split(' '));
            // Remove the event listener for all animation end types
            animationEndEvents.forEach(eventName => {
              el.removeEventListener(eventName, handler);
            });
          };
          // Add listeners for all possible animation end events
          animationEndEvents.forEach(eventName => {
            el.addEventListener(eventName, handler);
            this.animationHandlers.push({el, eventName, handler});
          });
        });
      }, i * inter * 4);
      this.animationTimeouts.push(timeout);
    }
  });
}

  //  loadCart() { 
  //     const cartId = this._cookie.get('cartId'); // Get cartId from cookies
  
  //     if (!cartId) {
  //         console.log("No cartId found. Setting cartItems to 0.");
  //         this.cartItems = 0; // Reset cart count
  //         return;
  //     } 
  
  //     this.cartService.getCart().subscribe(
  //         (cartData) => {
  //             if (!cartData || !cartData.body) {
  //                 console.warn("Cart data is empty or invalid:", cartData);
  //                 this.cartItems = 0;
  //                 return;
  //             }
  
  //             const products = Array.isArray(cartData.body.products) ? cartData.body.products : [];
  //             console.log("Cart products:", products);
  
  //             this.cartItems = products.reduce((total, product) => {
  //                 const quantity = (product && product.quantity) ? product.quantity : 0;
  //                 console.log(`Processing product:`, product, `Quantity:`, quantity);
  //                 return total + quantity;
  //             }, 0);
  
  //             console.log("Total cart items count:", this.cartItems);
              
  //         },
  //         (error) => {
  //             console.error("Error fetching cart:", error);
  //         }
  //     );
  
  //     // ✅ Sync with observable for real-time updates (use `take(1)` to prevent multiple executions)
  //     // this.cartService.cartItems$.pipe(take(1)).subscribe(cartCount => {
  //     //     console.log("Cart count updated from observable:", cartCount);
  //     //     this.cartItems = cartCount;
  //     // });
  // }
  loadCartt() { 
    const cartId = this._cookie.get('cartId'); // Get cartId from cookies
    
    if (!cartId) {
        this.cartItems = 0;
        console.warn("No cartId found. Skipping cart count update.");
        return;
    } 
    // this.cartService.cartItems$.subscribe(cartCount => {
    //   this.cartItems = cartCount;
    //   console.log("cartitems count",this.cartItems);
    // });
    this.cartService.getCart().pipe(
      debounceTime(500) ,
      distinctUntilChanged()
  ).subscribe(
        (cartData) => {
            if (cartData && cartData.body && cartData.body.products) {
                this.cartItems = cartData.body.products.reduce(
                    (total, product) => total + (product.quantity || 0), 0
                );
            } else {
                this.cartItems = 0;
            }
          
            console.log("Cart Items Count (Updated):", this.cartItems);
            this.cdr.detectChanges();
        },
        (error) => {
            console.error("Error fetching cart count:", error);
        }
    );
  }


    sidebarOpen = false;

  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
  }
}
